module.exports = __webpack_public_path__ + "static/img/1-1.fd31216.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/eng/1-1.png
// module id = tHx3
// module chunks = 0